import Rollbar from 'rollbar';
import { ErrorMessage, LogData, LogMessage } from '@flow/logging/types';

const critical = (message: ErrorMessage | LogMessage, data?: LogData) =>
  (Rollbar as any).critical(message, data);
const error = (message: ErrorMessage | LogMessage, data?: LogData) =>
  (Rollbar as any).error(message, data);

export const rollbarReporter = {
  critical,
  error,
};
